// extracted by mini-css-extract-plugin
export default {"addDocumentButton":"documents_addDocumentButton__Du300","docListContainer":"documents_docListContainer__QsPWq"};